import { mapGetters } from 'vuex'
import { VBtn } from 'vuetify/lib'
import VTable, { type_name } from '@/vuetify_custom/v-table/v1'
import VPage from '@/vuetify_custom/v-pagination'
import SearchBar from '@/vuetify_custom/v-form'
import PlainModal from './components/plan_modal'
import PlanModalEdit from './components/plan_modal_edit'
import { getCostPlansApi, deleteCostPlanBillApi } from './services'
const { BUTTON_A_FIELD, LIST_FIELD, BUTTON_G_FIELD,MONEY_FIELD } = type_name
export default {
    data() {
        return {
          list: [],
          params: {
            search:'',
            status: 'all', // 
            quarter_start_at: '',
            page:1,
            consume_month: '',
            per_page:20,
            total_count: 0,
            search_type: 'mine'
          },
          loading: {
            get:false
          }
        }
    },
    computed: {
      ...mapGetters('async', {
        companies: 'companies',
        teams: 'root_teams',
      }),
      tableFields() {
        return [
            {
              fixed:'left',
              text: '编号',
              width: 200,
              align: 'start',
              value: 'uid',
              type: BUTTON_A_FIELD,
              callback:(target) => {
                this.$router.push(`/fin/consumption_plan_bills/detail?id=${target.id}`)
              }
            },
            {
              text: '单据名称',
              align: 'center',
              value: 'name',
              width: 200,
            },
            {
              text: '总金额',
              align: 'end',
              type: MONEY_FIELD,
              value: 'total_price',
              width: 100,
            },
            {
              text: '合同',
              align: 'center',
              value: 'contract_id',
              width: 200,
            },
            {
              text: '起始日期',
              value: 'start_at',
              width: 150,
            },
            {
              text: '终止日期',
              value: 'end_at',
              width: 150,
            },
            {
              text: '关联公司',
              align: 'center',
              value: 'company_id',
              type: LIST_FIELD,
              item_key: 'id',
              item_text: 'short_name',
              items:this.companies,
              width: 100
            },
            {
              text: '关联团队',
              align: 'center',
              value: 'team_id',
              type: LIST_FIELD,
              item_key: 'id',
              item_text: 'name',
              items:this.teams,
              width: 100
            },
            {
                text: '申请用户名称',
                align: 'center',
                value: 'apply_user',
                width: 150
              },
              {
                text: '收款银行',
                align: 'center',
                value: 'payee_bank',
                width: 200
              },
              {
                text: '收款账号',
                align: 'center',
                value: 'payee_account_name',
                width: 200
              },
              {
                text: '收款银行号',
                align: 'center',
                value: 'payee_bank_number',
                width: 200
              },
              {
                text: '操作',
                b_text: '操作',
                align: 'center',
                width: 200,
                fixed: 'right',
                value: 'action_2',
                type: BUTTON_G_FIELD,
                // callBack: (btn, value) => {
                //   switch (btn.key) {
                //     case 'edit':
                //       this.$refs['plain-modal'].show(value)
                //       break;
                //     default:
                //       break;
                //   }
                // },
                buttons: [
                  {
                    text: '编辑',
                    key: 'edit',
                    color: 'primary',
                    small: true,
                    callback: (data) => {
                      this.$refs['plain-modal-edit'].show(data)
                    }
                  },
                  {
                    text: '停止',
                    key: 'edit',
                    color: 'primary',
                    small: true,
                    callback: (item) => {
                      this.$vModal.confirm({
                        title: '提示',
                        content: '确认停止当前消耗单？',
                        loading:true,
                        onOk:({
                          destroy,
                          stopLoading
                        }) => {
                          deleteCostPlanBillApi({id: item.id}).then(() => {
                            this.$Message.success({
                              content: '停止成功!'
                            });
                            destroy()
                            this.params.page = 1
                            this.getInitList()
                          }).finally(() => {
                            stopLoading()
                          })
                        }
                      })
                    }
                  }
                ]
              }
          ]
      },
      searchFields() {
        return [
          {
            label: '月份',
            key: 'consume_month',
            type: 'month_field',
            cols: 6,
          },
          {
            label: '搜索',
            type: 'text_field',
            key: 'search',
            cols: 6,
            placeholder: '请输入',
            'append-icon':'mdi-magnify',
            'single-line': true,
            clearable:true,
            'click:clear':this.getFirstPage,
            'click:append': this.getFirstPage,
            'keydown.enter': this.getFirstPage,
          }
        ]
      },
    },
    mounted() {
      this.getInitList()
      this.getLocalStorage()
    },
    methods: {
      getLocalStorage() {
       let local = localStorage.getItem('contract_generate_consume_plan');
       if (local) {
        local = JSON.parse(local)
        this.$refs['plain-modal'].showHasData(local)
        localStorage.removeItem('contract_generate_consume_plan')
       }
       },
      // getList() {
      //   getCostPlansApi().then(res => {
      //     this.list = res.bills
      //   })
      // },
      // 初始化刷新
      getFirstPage() {
        this.getInitList({page:1})
      },
      getInitList({page, per_page} = {}) {
        this.loading.get = true
        this.params.page = page || this.params.page
        this.params.per_page = per_page || this.params.page
        getCostPlansApi(this.params).then(({cur_page, per_page, total_count, bills}) => {
          bills = bills || []
          this.params.total_count = total_count
          this.params.per_page = per_page
          this.params.page = cur_page
          this.list = bills
        }).finally(() => {
          this.loading.get = false
        })
      }
    },
    render() {
      const _this = this
        return (<div>
            <div style="display:flex">
              <SearchBar 
                v-model={this.params}
                cols={12}
                style="max-width:600px"
                fields={this.searchFields}
              />
                <div style="display:flex;align-items:center">
                  <VBtn
                    depressed
                    color="primary"
                    style="margin-left:10px"
                    on = {
                      {
                        click:() => {
                          this.$refs['plain-modal'].show()
                        }
                      }
                    }
                  >
                    新增消耗计划单
                  </VBtn>
                </div>
            </div>
            <VTable
             headers={this.tableFields}
             desserts={this.list}
             loading={_this.loading.get}
             scopedSlots={{
              action_2(val, data) {
                return <div> <VBtn
                  style={{
                    marginRight: '10px'
                  }}
                    depressed
                    small
                    color="primary"
                    onClick={() => {
                      _this.$refs['plain-modal-edit'].show(data)
                    }}
                  >
                    编辑
                  </VBtn>
                  {!data.del && <VBtn
                    depressed
                    small
                    color="error"
                    onClick={() => {
                      _this.$vModal.confirm({
                        title: '提示',
                        content: '确认停止当前消耗单？',
                        loading:true,
                        onOk:({
                          destroy,
                          stopLoading
                        }) => {
                          deleteCostPlanBillApi({id: data.id}).then(() => {
                            _this.$Message.success({
                              content: '停止成功!'
                            });
                            destroy()
                            _this.params.page = 1
                            _this.getInitList()
                          }).finally(() => {
                            stopLoading()
                          })
                        }
                      })
                    }}
                  >
                    停止
                  </VBtn>}
                  </div>
              },
              uid(val, target) {
                return <p style={{
                  padding: 0,
                  margin: 0
                }}><a onClick={() => {
                  _this.$router.push(`/fin/consumption_plan_bills/detail?id=${target.id}`)
                }}>{val}</a>{target.del && <span style={{
                  color: 'red'
                }}>[已停止]</span>}</p>
              },
              contract_id(val, target) {
               const contract = target.contract || {}
                return <p style={{
                  padding: 0,
                  margin: 0
                }}>{`${contract.uid}-${contract.name}`}</p>
              }
             }}
            />
            <PlainModal 
              ref="plain-modal"
              on = {
                {
                  success: () => {
                    setTimeout(() => {
                      _this.getFirstPage()
                    }, 200) 
                  }
                }
              }
            />
            <PlanModalEdit 
              ref="plain-modal-edit"
              on={{
                success: () => {
                  _this.getFirstPage()
                }
              }}
            />
            <div class="paginate-fix-bottom">
              <VPage
                current={this.params.page}
                total={this.params.total_count}
                page-size={this.params.per_page}
                size-arr={[10, 20, 50]}
                on={
                  {
                    changePageSize:(per_page) => {
                      this.getInitList({
                        page:1,
                        per_page
                      })
                    },
                    pageChange:(page) => {
                      this.getInitList({
                        page
                      })
                    }
                  }
                }
              />
            </div>
        </div>)
    }
}